import { useEffect, useMemo, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { useSelector } from 'react-redux';
import fetchWrapper from '../clients/fetchWrapper';
import { selectLinkParams } from '../state/slices/slice-link-params';
export default function useDownloadResource(url) {
    var _a = useState(''), blobUrl = _a[0], setBlobUrl = _a[1];
    var _b = useState(false), blobUrlLoaded = _b[0], setBlobUrlLoaded = _b[1];
    var _c = useState(new Blob()), blob = _c[0], setBlob = _c[1];
    var _d = useSelector(selectLinkParams), sdk = _d.sdk, platform = _d.platform;
    useEffect(function () {
        setBlobUrlLoaded(false);
        if (!url)
            return;
        // TODO: this logic should be updated/removed as the assumptions listed below are flawed:
        //       - the react-native SDK now is a wrapper over the Android SDK
        //       - running Portal on Android would not cause this check to pass, as 'platform' would be set to 'web'
        //         regardless of whether it's being run on Android or not.
        // Blob downloads don't seem to work with android devices; there is a fix for the android SDK but not for portal/react-native
        if (platform === 'android' && sdk !== 'android') {
            setBlobUrl(url);
            setBlobUrlLoaded(true);
            return;
        }
        fetchWrapper(url)
            // Convert PDF to a blob so that it can be directly downloaded. Otherwise,
            // we run into CORS/sandbox issues with some customers (e.g. CK) when
            // opening up the S3 URL directly via a new tab / popup:
            // https://medium.com/charisol-community/downloading-resources-in-html5-a-download-may-not-work-as-expected-bf63546e2baa
            .then(function (response) { return response.blob(); })
            .then(function (responseBlob) {
            setBlob(responseBlob);
            setBlobUrl(URL.createObjectURL(responseBlob));
            setBlobUrlLoaded(true);
        })
            .catch(function (downloadError) {
            datadogLogs.logger.log('download_resource_failed', {
                unknownError: downloadError,
            });
            // If the blob conversion fails for any reason (this shouldn't happen in
            // practice though), fallback to the original S3 URL.
            setBlobUrl(url || '');
            setBlobUrlLoaded(true);
        });
    }, [platform, sdk, url]);
    var result = useMemo(function () { return ({
        blob: blob,
        blobUrl: blobUrl,
        blobUrlLoaded: blobUrlLoaded,
    }); }, [blob, blobUrl, blobUrlLoaded]);
    return result;
}
